import * as React from 'react';

export const getBuildNumber = () => {
  const version = process.env.REACT_APP_VERSION;
  const nodeEnv = process.env.NODE_ENV;
  let retVal = 'undefined';
  if (nodeEnv === 'development') {
    retVal = 'development';
  } else {
    if (version) {
      if (version.indexOf('beta') > 0) {
        retVal = 'develop-';
      } else if (version.indexOf('staging') > 0) {
        retVal = 'staging-';
      } else {
        retVal = 'master-';
      }
      retVal += version.substring(version.lastIndexOf('.') + 1, version.length);
    }
  }
  return retVal;
};

export const getEnvironment = () => {
  const version = process.env.REACT_APP_VERSION;
  const nodeEnv = process.env.NODE_ENV;
  if (nodeEnv === 'development') {
    return 'development';
  }
  if (version) {
    if (version.indexOf('beta') > 0) {
      return 'beta';
    } else {
      return 'production';
    }
  }
};

export const getBuildDate = () => {
  const date = process.env.REACT_APP_BUILD_DATE;
  if (date) {
    return date;
  }
  return 'NA';
};

export class VersionNumber extends React.PureComponent {
  render() {
    return (
      <div>
        <span>Build: {getBuildNumber()}</span>
        <br />
        <span>Date: {getBuildDate()}</span>
      </div>
    );
  }
}
